import Layout from '@/apps/layout/components'
import NewsDetail from '@/apps/NewsDetail'
import React from 'react'

const NewsDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <NewsDetail />
    </Layout>
  )
}

export default NewsDetailPage
